import { Table as TableIcon, LayoutGrid } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { TableViewMode } from "@/hooks/useTableViewMode";

interface TableViewToggleProps {
  viewMode: TableViewMode;
  onChange: (mode: TableViewMode) => void;
}

/**
 * Selector segmentado para alternar entre vista de tabla y vista de tarjetas.
 * Se ubica a la izquierda del control de visibilidad de columnas.
 */
export function TableViewToggle({ viewMode, onChange }: TableViewToggleProps) {
  return (
    <div className="inline-flex items-center rounded-xl border border-border p-0.5">
      <Button
        type="button"
        variant={viewMode === "table" ? "subtle" : "ghost"}
        size="sm"
        className="h-7 w-7 p-0"
        aria-pressed={viewMode === "table"}
        title="Vista de tabla"
        onClick={() => onChange("table")}
      >
        <TableIcon
          className={cn("h-4 w-4", viewMode !== "table" && "opacity-60")}
        />
      </Button>
      <Button
        type="button"
        variant={viewMode === "cards" ? "subtle" : "ghost"}
        size="sm"
        className="h-7 w-7 p-0"
        aria-pressed={viewMode === "cards"}
        title="Vista de tarjetas"
        onClick={() => onChange("cards")}
      >
        <LayoutGrid
          className={cn("h-4 w-4", viewMode !== "cards" && "opacity-60")}
        />
      </Button>
    </div>
  );
}

export default TableViewToggle;
